import { HeroButton } from 'suf_storybook/src/components/SustainableFitch/SFHero/SFHero'
import _, { get } from 'lodash'
import { CTAButtonProps } from 'suf_storybook'
import loadMarketoForm from './loadMarketoForm'

export type Banner = {
  bannerText: Object
  cta?: HeroButton[]
  ctaButton?: HeroButton[]
  defaultCtaLabel: string
  defaultCtaLink: string
  image: object
  racTeaserOff: boolean
  subTitle: string
  title: string
  video: string
  ctaContent: CTAButtonProps
  mktoFormId?: string
  fullLengthForm?: boolean
}

export default function parseBannerProps(
  banner: Banner,
  landingMarketoFormId?: string,
  landingFullLengthMarketoForm?: boolean
) {
  const parseHeroButtonsProps = ({
    cta,
    ctaButton,
    defaultCtaLabel = '',
    defaultCtaLink = ''
  }: Banner): HeroButton[] => {
    const defaultCta = {
      label: defaultCtaLabel,
      href: defaultCtaLink
    }
    const predefinedCta = _.map(
      cta || ctaButton,
      ({ href, label, marketoFormId, target, dataTitle }) => ({
        label,
        href: _.get(href, 'href', ''),
        marketoFormId,
        target,
        isSectionLayout: false,
        dataTitle
      })
    )

    return defaultCta && defaultCtaLink
      ? [defaultCta, ...predefinedCta]
      : predefinedCta
  }
  return {
    image: banner?.image,
    imageGradient: _.get(banner, 'imageGradient', true),
    subTitle: _.get(banner, 'subTitle', ''),
    svgButtons: parseHeroButtonsProps(banner),
    text: _.get(banner, 'bannerText.childMarkdownRemark.html'),
    video: banner?.video,
    title: banner?.title,
    ctaContent: {
      cta: get(banner, 'ctaContent.cta', ''),
      link: get(banner, 'ctaContent.link.link', ''),
      target: get(banner, 'ctaContent.target', ''),
      ctaBackgroundColor: get(banner, 'ctaContent.ctaBackgroundColor', '')
    },
    marketoFormId: banner?.mktoFormId || landingMarketoFormId,
    marketoLauncher: loadMarketoForm,
    fullLengthForm: banner?.fullLengthForm || landingFullLengthMarketoForm
  }
}
